import styled from 'styled-components'

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;

  @media (min-width: ${({ theme }) => theme.screen.lgMin}) {
    flex-direction: row;
    justify-content: space-between;
  }

  & a:hover {
    text-decoration: none;
    color: ${({ theme }) => theme.colors.primary.normal};
    cursor: pointer;
  }
`

export const ImageWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  @media (min-width: ${({ theme }) => theme.screen.mdmMin}) {
    justify-content: flex-start;
  }
`

export const TextWrapper = styled.div`
  width: 100%;
  margin: 32px 0px 24px;
  padding: 0 4px;

  @media (min-width: ${({ theme }) => theme.screen.lgMin}) {
    margin: 82px 0px;
  }
`

export const Image = styled.div`
  background-image: url(${({ bg }) => bg});
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: cover;
  width: 100%;
  height: 100%;
  min-height: 50vw;

  @media (min-width: ${({ theme }) => theme.screen.mdMin}) {
    background-size: contain;
    min-height: 272px;
  }

  @media (min-width: ${({ theme }) => theme.screen.lgMin}) {
    background-size: cover;
    background-position: center;
    background-position-x: -240px;
  }

  @media (min-width: ${({ theme }) => theme.screen.xlMin}) {
    background-position-x: center;
  }
`

export const Title = styled.h2`
  color: #ffff;
  font-size: 32px;
  font-weight: 600;
  line-height: 40px;
  margin-bottom: 24px;
`

export const SubTitle = styled.p`
  color: #ffff;
  margin-bottom: 32px;
  font-weight: 400;
  line-height: 24px;
  font-size: 16px;

  @media (min-width: ${({ theme }) => theme.screen.mdMin}) {
    font-size: 18px;
  }
`

export const List = styled.ul`
  padding: 0px;
  margin: 0px 0px 32px 0px;

  & li {
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 0px;
    }
  }
`

export const Item = styled.li`
  display: flex;
  align-items: flex-start;
`

export const Description = styled.p`
  font-weight: 600;
  line-height: 20px;
  color: #ffff;
  margin: 0px 0px 0px 12px;
  font-size: 14px;

  @media (min-width: ${({ theme }) => theme.screen.mdMin}) {
    font-size: 16px;
  }
`

export const CustomLink = styled.a`
  display: block;
  text-decoration: none;
  width: 100%;
  max-width: 160px;
  background-color: #ffff;
  border: 1px solid #ffff;
  color: ${({ theme }) => theme.colors.primary.normal};
  margin: 0 auto;
  padding: 15px;
  border-radius: 8px;

  font-size: 16px;
  font-weight: 600;
  line-height: 18px;
  text-align: center;
`
